export default {
    groupName: 'disneyhulu',
    appName: 'Disney',
    baseRoute: '/dashboard/disneyhulu',
    label: 'Ad Effect Tracker',
    home: '/slicer',
    image: 'disneyhulu.png',
    description: 'Disney DTC Ad Effect Tracker Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/main.js